import { createSlug } from '@/@core/utils/string-utils';
import {
    ListingResponseDtoPropertyCategory,
    ListingDetailResponseDtoApartmentSubtype,
    ListingDetailResponseDtoLandSubtype,
    ListingDetailResponseDtoRecreationalSubtype,
    ListingDetailResponseDtoHouseSubtype,
    ListingDetailResponseDtoOtherSubtype,
} from '@/api/generated/model';

export const ListingPropertyCategory = ListingResponseDtoPropertyCategory;

export type ListingPropertyCategory =
    (typeof ListingPropertyCategory)[keyof typeof ListingPropertyCategory];

export const ListingDetailApartmentSubtype = ListingDetailResponseDtoApartmentSubtype;

export type ListingDetailApartmentSubtype =
    (typeof ListingDetailApartmentSubtype)[keyof typeof ListingDetailApartmentSubtype];

export const ListingApartmentRoomCount = {
    APARTMENT_ROOMS_1: 'APARTMENT_ROOMS_1',
    APARTMENT_ROOMS_2: 'APARTMENT_ROOMS_2',
    APARTMENT_ROOMS_3: 'APARTMENT_ROOMS_3',
    APARTMENT_ROOMS_4: 'APARTMENT_ROOMS_4',
    APARTMENT_ROOMS_5_PLUS: 'APARTMENT_ROOMS_5_PLUS',
} as const;

export type ListingApartmentRoomCount =
    (typeof ListingApartmentRoomCount)[keyof typeof ListingApartmentRoomCount];

export const ListingDetailLandSubtype = ListingDetailResponseDtoLandSubtype;

export type ListingDetailLandSubtype =
    (typeof ListingDetailLandSubtype)[keyof typeof ListingDetailLandSubtype];

export const ListingDetailHouseSubtype = ListingDetailResponseDtoHouseSubtype;

export type ListingDetailHouseSubtype =
    (typeof ListingDetailHouseSubtype)[keyof typeof ListingDetailHouseSubtype];

export const ListingDetailRecreationalSubtype = ListingDetailResponseDtoRecreationalSubtype;

export type ListingDetailRecreationalSubtype =
    (typeof ListingDetailRecreationalSubtype)[keyof typeof ListingDetailRecreationalSubtype];

export const ListingDetailOtherSubtype = ListingDetailResponseDtoOtherSubtype;

export type ListingDetailOtherSubtype =
    (typeof ListingDetailOtherSubtype)[keyof typeof ListingDetailOtherSubtype];

export const LISTING_PROPERTY_SUBTYPES_BY_CATEGORY = {
    [ListingPropertyCategory.APARTMENT]: ListingDetailApartmentSubtype,
    [ListingPropertyCategory.HOUSE]: ListingDetailHouseSubtype,
    [ListingPropertyCategory.LAND]: ListingDetailLandSubtype,
    [ListingPropertyCategory.OTHER]: ListingDetailOtherSubtype,
    [ListingPropertyCategory.RECREATIONAL]: ListingDetailRecreationalSubtype,
};

export const LISTING_PROPERTY_SUBTYPE_HOUSE_KEYS = [
    ListingDetailHouseSubtype.BUNGALOW,
    ListingDetailHouseSubtype.COUNTRY_HOUSE,
    ListingDetailHouseSubtype.FAMILY_HOUSE,
    ListingDetailHouseSubtype.HOUSEBOAT,
    ListingDetailHouseSubtype.LOG_HOUSE,
    ListingDetailHouseSubtype.MOBILE_HOUSE,
    ListingDetailHouseSubtype.VILLA,
] as const;

export const LISTING_PROPERTY_SUBTYPE_APARTMENT_KEYS = [
    ListingDetailApartmentSubtype.STANDARD,
    ListingDetailApartmentSubtype.LOFT,
    ListingDetailApartmentSubtype.MAISONETTE,
    ListingDetailApartmentSubtype.PENTHOUSE,
] as const;

export const LISTING_PROPERTY_SUBTYPE_LAND_KEYS = [
    ListingDetailLandSubtype.AGRICULTURAL_LAND,
    ListingDetailLandSubtype.APARTMENT_DEVELOPMENT_PLOT,
    ListingDetailLandSubtype.COMMERCIAL_DEVELOPMENT_PLOT,
    ListingDetailLandSubtype.FAMILY_HOUSE_PLOT,
    ListingDetailLandSubtype.FOREST,
    ListingDetailLandSubtype.ORCHARD,
    ListingDetailLandSubtype.RECREATIONAL_GARDEN_PLOT,
    ListingDetailLandSubtype.VINEYARD,
] as const;

export const LISTING_PROPERTY_SUBTYPE_RECREATIONAL_KEYS = [
    ListingDetailRecreationalSubtype.APARTMENT,
    ListingDetailRecreationalSubtype.COTTAGE,
    ListingDetailRecreationalSubtype.GARDEN_COTTAGE,
] as const;

export const LISTING_PROPERTY_SUBTYPE_OTHER_KEYS = [
    ListingDetailOtherSubtype.APARTMENT_BUILDING,
    ListingDetailOtherSubtype.GARAGE_OR_PARKING,
    ListingDetailOtherSubtype.HOTEL_OR_GUESTHOUSE,
    ListingDetailOtherSubtype.MEDICAL,
    ListingDetailOtherSubtype.MULTIFUNCTIONAL_BUILDING,
    ListingDetailOtherSubtype.OFFICE,
    ListingDetailOtherSubtype.PRODUCTION,
    ListingDetailOtherSubtype.RESTAURANT,
    ListingDetailOtherSubtype.RETAIL,
    ListingDetailOtherSubtype.WAREHOUSE,
] as const;

/*
export const LISTING_PROPERTY_SUBTYPE_LABELS: Record<string, string> = {
    // HOUSE
    [ListingDetailHouseSubtype.BUNGALOW]: 'Bungalov',
    [ListingDetailHouseSubtype.COUNTRY_HOUSE]: 'Vidiecky dom',
    [ListingDetailHouseSubtype.FAMILY_HOUSE]: 'Rodinný dom',
    [ListingDetailHouseSubtype.HOUSEBOAT]: 'Hausbot',
    [ListingDetailHouseSubtype.LOG_HOUSE]: 'Zrubový dom',
    [ListingDetailHouseSubtype.MOBILE_HOUSE]: 'Mobilný dom',
    [ListingDetailHouseSubtype.VILLA]: 'Vila',

    // APARTMENT
    [ListingDetailApartmentSubtype.STANDARD]: 'Apartmán',
    [ListingDetailApartmentSubtype.LOFT]: 'Loft',
    [ListingDetailApartmentSubtype.MAISONETTE]: 'Mezonet',
    [ListingDetailApartmentSubtype.PENTHOUSE]: 'Penthouse',

    // APARTMENT ROOMS
    APARTMENT_ROOMS_1: '1 a 1,5 izbový byt',
    APARTMENT_ROOMS_2: '2 a 2,5 izbový byt',
    APARTMENT_ROOMS_3: '3 a 3,5 izbový byt',
    APARTMENT_ROOMS_4: '4 a 4,5 izbový byt',
    APARTMENT_ROOMS_5_PLUS: '5 a viac izbový byt',

    // LAND
    [ListingDetailLandSubtype.AGRICULTURAL_LAND]: 'Poľnohospodárska pôda',
    [ListingDetailLandSubtype.APARTMENT_DEVELOPMENT_PLOT]: 'Pozemok pre bytovú výstavbu',
    [ListingDetailLandSubtype.COMMERCIAL_DEVELOPMENT_PLOT]: 'Pozemok pre komerčnú výstavbu',
    [ListingDetailLandSubtype.FAMILY_HOUSE_PLOT]: 'Pozemok pre rodinný dom',
    [ListingDetailLandSubtype.FOREST]: 'Lesný pozemok',
    [ListingDetailLandSubtype.ORCHARD]: 'Ovocný sad',
    [ListingDetailLandSubtype.RECREATIONAL_GARDEN_PLOT]: 'Rekreačný pozemok / záhrada',
    [ListingDetailLandSubtype.VINEYARD]: 'Vinica',

    // RECREATIONAL
    // [ListingDetailRecreationalSubtype.APARTMENT]: 'Rekreačný apartmán',
    [ListingDetailRecreationalSubtype.COTTAGE]: 'Chata',
    [ListingDetailRecreationalSubtype.GARDEN_COTTAGE]: 'Záhradná chatka',

    // OTHER
    [ListingDetailOtherSubtype.APARTMENT_BUILDING]: 'Bytový dom',
    [ListingDetailOtherSubtype.GARAGE_OR_PARKING]: 'Garáž / parkovacie miesto',
    [ListingDetailOtherSubtype.HOTEL_OR_GUESTHOUSE]: 'Hotel / penzión',
    [ListingDetailOtherSubtype.MEDICAL]: 'Zdravotnícke zariadenie',
    [ListingDetailOtherSubtype.MULTIFUNCTIONAL_BUILDING]: 'Polyfunkčný objekt',
    [ListingDetailOtherSubtype.OFFICE]: 'Kancelárske priestory',
    [ListingDetailOtherSubtype.PRODUCTION]: 'Výrobný objekt',
    [ListingDetailOtherSubtype.RESTAURANT]: 'Reštaurácia / gastro prevádzka',
    [ListingDetailOtherSubtype.RETAIL]: 'Obchodné priestory',
    [ListingDetailOtherSubtype.WAREHOUSE]: 'Sklad / skladové priestory',
};
*/
export const LISTING_PROPERTY_SUBTYPE_LABELS = {
    // HOUSE
    [`${ListingPropertyCategory.HOUSE}_${ListingDetailHouseSubtype.BUNGALOW}`]: 'Bungalov',
    [`${ListingPropertyCategory.HOUSE}_${ListingDetailHouseSubtype.COUNTRY_HOUSE}`]: 'Vidiecky dom',
    [`${ListingPropertyCategory.HOUSE}_${ListingDetailHouseSubtype.FAMILY_HOUSE}`]: 'Rodinný dom',
    [`${ListingPropertyCategory.HOUSE}_${ListingDetailHouseSubtype.HOUSEBOAT}`]: 'Hausbot',
    [`${ListingPropertyCategory.HOUSE}_${ListingDetailHouseSubtype.LOG_HOUSE}`]: 'Zrubový dom',
    [`${ListingPropertyCategory.HOUSE}_${ListingDetailHouseSubtype.MOBILE_HOUSE}`]: 'Mobilný dom',
    [`${ListingPropertyCategory.HOUSE}_${ListingDetailHouseSubtype.VILLA}`]: 'Vila',

    // APARTMENT
    [`${ListingPropertyCategory.APARTMENT}_${ListingDetailApartmentSubtype.STANDARD}`]: 'Apartmán',
    [`${ListingPropertyCategory.APARTMENT}_${ListingDetailApartmentSubtype.LOFT}`]: 'Loft',
    [`${ListingPropertyCategory.APARTMENT}_${ListingDetailApartmentSubtype.MAISONETTE}`]: 'Mezonet',
    [`${ListingPropertyCategory.APARTMENT}_${ListingDetailApartmentSubtype.PENTHOUSE}`]:
        'Penthouse',

    // APARTMENT ROOMS
    [`${ListingPropertyCategory.APARTMENT}_${ListingApartmentRoomCount.APARTMENT_ROOMS_1}`]:
        '1 a 1,5 izbový byt',
    [`${ListingPropertyCategory.APARTMENT}_${ListingApartmentRoomCount.APARTMENT_ROOMS_2}`]:
        '2 a 2,5 izbový byt',
    [`${ListingPropertyCategory.APARTMENT}_${ListingApartmentRoomCount.APARTMENT_ROOMS_3}`]:
        '3 a 3,5 izbový byt',
    [`${ListingPropertyCategory.APARTMENT}_${ListingApartmentRoomCount.APARTMENT_ROOMS_4}`]:
        '4 a 4,5 izbový byt',
    [`${ListingPropertyCategory.APARTMENT}_${ListingApartmentRoomCount.APARTMENT_ROOMS_5_PLUS}`]:
        '5 a viac izbový byt',

    // LAND
    [`${ListingPropertyCategory.LAND}_${ListingDetailLandSubtype.AGRICULTURAL_LAND}`]:
        'Poľnohospodárska pôda',
    [`${ListingPropertyCategory.LAND}_${ListingDetailLandSubtype.APARTMENT_DEVELOPMENT_PLOT}`]:
        'Pozemok pre bytovú výstavbu',
    [`${ListingPropertyCategory.LAND}_${ListingDetailLandSubtype.COMMERCIAL_DEVELOPMENT_PLOT}`]:
        'Pozemok pre komerčnú výstavbu',
    [`${ListingPropertyCategory.LAND}_${ListingDetailLandSubtype.FAMILY_HOUSE_PLOT}`]:
        'Pozemok pre rodinný dom',
    [`${ListingPropertyCategory.LAND}_${ListingDetailLandSubtype.FOREST}`]: 'Lesný pozemok',
    [`${ListingPropertyCategory.LAND}_${ListingDetailLandSubtype.ORCHARD}`]: 'Ovocný sad',
    [`${ListingPropertyCategory.LAND}_${ListingDetailLandSubtype.RECREATIONAL_GARDEN_PLOT}`]:
        'Rekreačný pozemok / záhrada',
    [`${ListingPropertyCategory.LAND}_${ListingDetailLandSubtype.VINEYARD}`]: 'Vinica',

    // RECREATIONAL
    [`${ListingPropertyCategory.RECREATIONAL}_${ListingDetailRecreationalSubtype.COTTAGE}`]:
        'Chata',
    [`${ListingPropertyCategory.RECREATIONAL}_${ListingDetailRecreationalSubtype.GARDEN_COTTAGE}`]:
        'Záhradná chatka',

    // OTHER
    [`${ListingPropertyCategory.OTHER}_${ListingDetailOtherSubtype.APARTMENT_BUILDING}`]:
        'Bytový dom',
    [`${ListingPropertyCategory.OTHER}_${ListingDetailOtherSubtype.GARAGE_OR_PARKING}`]:
        'Garáž / parkovacie miesto',
    [`${ListingPropertyCategory.OTHER}_${ListingDetailOtherSubtype.HOTEL_OR_GUESTHOUSE}`]:
        'Hotel / penzión',
    [`${ListingPropertyCategory.OTHER}_${ListingDetailOtherSubtype.MEDICAL}`]:
        'Zdravotnícke zariadenie',
    [`${ListingPropertyCategory.OTHER}_${ListingDetailOtherSubtype.MULTIFUNCTIONAL_BUILDING}`]:
        'Polyfunkčný objekt',
    [`${ListingPropertyCategory.OTHER}_${ListingDetailOtherSubtype.OFFICE}`]:
        'Kancelárske priestory',
    [`${ListingPropertyCategory.OTHER}_${ListingDetailOtherSubtype.PRODUCTION}`]: 'Výrobný objekt',
    [`${ListingPropertyCategory.OTHER}_${ListingDetailOtherSubtype.RESTAURANT}`]:
        'Reštaurácia / gastro prevádzka',
    [`${ListingPropertyCategory.OTHER}_${ListingDetailOtherSubtype.RETAIL}`]: 'Obchodné priestory',
    [`${ListingPropertyCategory.OTHER}_${ListingDetailOtherSubtype.WAREHOUSE}`]:
        'Sklad / skladové priestory',
} as const;

export const LISTING_PROPERTY_SUBTYPE_HOUSE_OPTIONS = LISTING_PROPERTY_SUBTYPE_HOUSE_KEYS.map(
    (key) => ({
        key: `${ListingPropertyCategory.HOUSE}_${key}`,
        originalKey: key,
        text: LISTING_PROPERTY_SUBTYPE_LABELS[`${ListingPropertyCategory.HOUSE}_${key}`],
        slug: createSlug(
            LISTING_PROPERTY_SUBTYPE_LABELS[`${ListingPropertyCategory.HOUSE}_${key}`],
        ),
    }),
);

export const LISTING_APARTMENT_ROOM_COUNT_KEYS = [
    ListingApartmentRoomCount.APARTMENT_ROOMS_1,
    ListingApartmentRoomCount.APARTMENT_ROOMS_2,
    ListingApartmentRoomCount.APARTMENT_ROOMS_3,
    ListingApartmentRoomCount.APARTMENT_ROOMS_4,
    ListingApartmentRoomCount.APARTMENT_ROOMS_5_PLUS,
] as const;

export const LISTING_APARTMENT_ROOM_COUNT_MAPPING = {
    APARTMENT_ROOMS_1: [1, 1.5],
    APARTMENT_ROOMS_2: [2, 2.5],
    APARTMENT_ROOMS_3: [3, 3.5],
    APARTMENT_ROOMS_4: [4, 4.5],
    APARTMENT_ROOMS_5_PLUS: [5, 5.5, 6, 6.5, 7],
} as const;

export const LISTING_APARTMENT_ROOM_COUNT_LABELS: Record<ListingApartmentRoomCount, string> = {
    APARTMENT_ROOMS_1: '1 a 1,5 izbový byt',
    APARTMENT_ROOMS_2: '2 a 2,5 izbový byt',
    APARTMENT_ROOMS_3: '3 a 3,5 izbový byt',
    APARTMENT_ROOMS_4: '4 a 4,5 izbový byt',
    APARTMENT_ROOMS_5_PLUS: '5 a viac izbový byt',
} as const;

export const LISTING_PROPERTY_SUBTYPE_APARTMENT_OPTIONS = [
    ...LISTING_APARTMENT_ROOM_COUNT_KEYS,
    ...LISTING_PROPERTY_SUBTYPE_APARTMENT_KEYS,
].map((key) => ({
    key: `${ListingPropertyCategory.APARTMENT}_${key}`,
    originalKey: key,
    text: LISTING_PROPERTY_SUBTYPE_LABELS[`${ListingPropertyCategory.APARTMENT}_${key}`],
    slug: createSlug(
        LISTING_PROPERTY_SUBTYPE_LABELS[`${ListingPropertyCategory.APARTMENT}_${key}`],
    ),
}));

export const LISTING_PROPERTY_SUBTYPE_LAND_OPTIONS = LISTING_PROPERTY_SUBTYPE_LAND_KEYS.map(
    (key) => ({
        key: `${ListingPropertyCategory.LAND}_${key}`,
        originalKey: key,
        text: LISTING_PROPERTY_SUBTYPE_LABELS[`${ListingPropertyCategory.LAND}_${key}`],
        slug: createSlug(LISTING_PROPERTY_SUBTYPE_LABELS[`${ListingPropertyCategory.LAND}_${key}`]),
    }),
);

export const LISTING_PROPERTY_SUBTYPE_RECREATIONAL_OPTIONS =
    LISTING_PROPERTY_SUBTYPE_RECREATIONAL_KEYS.map((key) => ({
        key: `${ListingPropertyCategory.RECREATIONAL}_${key}`,
        originalKey: key,
        text: LISTING_PROPERTY_SUBTYPE_LABELS[`${ListingPropertyCategory.RECREATIONAL}_${key}`],
        slug: createSlug(
            LISTING_PROPERTY_SUBTYPE_LABELS[`${ListingPropertyCategory.RECREATIONAL}_${key}`],
        ),
    }));

export const LISTING_PROPERTY_SUBTYPE_OTHER_OPTIONS = LISTING_PROPERTY_SUBTYPE_OTHER_KEYS.map(
    (key) => ({
        key: `${ListingPropertyCategory.OTHER}_${key}`,
        originalKey: key,
        text: LISTING_PROPERTY_SUBTYPE_LABELS[`${ListingPropertyCategory.OTHER}_${key}`],
        slug: createSlug(
            LISTING_PROPERTY_SUBTYPE_LABELS[`${ListingPropertyCategory.OTHER}_${key}`],
        ),
    }),
);

export const LISTING_PROPERTY_SUBTYPE_OPTIONS_BY_CATEGORY = {
    ['HOUSE']: LISTING_PROPERTY_SUBTYPE_HOUSE_OPTIONS,
    ['APARTMENT']: LISTING_PROPERTY_SUBTYPE_APARTMENT_OPTIONS,
    ['LAND']: LISTING_PROPERTY_SUBTYPE_LAND_OPTIONS,
    ['RECREATIONAL']: LISTING_PROPERTY_SUBTYPE_RECREATIONAL_OPTIONS,
    ['OTHER']: LISTING_PROPERTY_SUBTYPE_OTHER_OPTIONS,
} as const;

export const LISTING_PROPERTY_SUBTYPE_OPTIONS = Object.values(
    LISTING_PROPERTY_SUBTYPE_OPTIONS_BY_CATEGORY,
).flat();

/*
export type ListingPropertySubtype =
    | ListingApartmentRoomCount
    | (typeof ListingDetailApartmentSubtype)[keyof typeof ListingDetailApartmentSubtype]
    | (typeof ListingDetailHouseSubtype)[keyof typeof ListingDetailHouseSubtype]
    | (typeof ListingDetailLandSubtype)[keyof typeof ListingDetailLandSubtype]
    | (typeof ListingDetailOtherSubtype)[keyof typeof ListingDetailOtherSubtype]
    | (typeof ListingDetailRecreationalSubtype)[keyof typeof ListingDetailRecreationalSubtype];
*/

export type ListingPropertySubtype =
    | `${typeof ListingPropertyCategory.HOUSE}_${ListingDetailHouseSubtype}`
    | `${typeof ListingPropertyCategory.APARTMENT}_${ListingApartmentRoomCount}`
    | `${typeof ListingPropertyCategory.APARTMENT}_${ListingDetailApartmentSubtype}`
    | `${typeof ListingPropertyCategory.LAND}_${ListingDetailLandSubtype}`
    | `${typeof ListingPropertyCategory.RECREATIONAL}_${ListingDetailRecreationalSubtype}`
    | `${typeof ListingPropertyCategory.OTHER}_${ListingDetailOtherSubtype}`;

export type ListingPropertyOriginalSubtype =
    | ListingApartmentRoomCount
    | (typeof ListingDetailApartmentSubtype)[keyof typeof ListingDetailApartmentSubtype]
    | (typeof ListingDetailHouseSubtype)[keyof typeof ListingDetailHouseSubtype]
    | (typeof ListingDetailLandSubtype)[keyof typeof ListingDetailLandSubtype]
    | (typeof ListingDetailOtherSubtype)[keyof typeof ListingDetailOtherSubtype]
    | (typeof ListingDetailRecreationalSubtype)[keyof typeof ListingDetailRecreationalSubtype];
